import { Link } from 'react-router-dom';
import { Spinner } from '@library/components/Spinner';
import { UserMenu } from '@library/components/menus';
import { useAlertNotificationsCount } from '@bo-hooks/alerts/useAlertNotificationsCount';

export interface UserDetailsProps {
  disabled: boolean;
  firstName?: string;
  googleAvatarUrl?: string;
  handleOnLogoutClick: () => void;
  lastName?: string;
}

export const UserDetails = ({
  disabled,
  firstName = undefined,
  googleAvatarUrl = undefined,
  handleOnLogoutClick,
  lastName = undefined
}: UserDetailsProps) => {
  const { hasAlertsAccess, unreadAlertNotificationsCount } =
    useAlertNotificationsCount();

  return (
    <div className="flex flex-col items-start gap-y-4">
      <div className="pr-2">
        {hasAlertsAccess && (
          <Link
            className="flex items-center"
            title="Alert Notifications"
            to="/alerts"
          >
            <div
              className={`${!unreadAlertNotificationsCount || unreadAlertNotificationsCount?.data?.unread_count === 0 ? 'bg-soFresh-140' : 'bg-stankonia-100'} flex size-4 items-center justify-center rounded-full text-[10px] text-white`}
            >
              {unreadAlertNotificationsCount ? (
                unreadAlertNotificationsCount?.data?.unread_count
              ) : (
                <Spinner />
              )}
            </div>
            <span className="pl-2 text-xs">Notifications</span>
          </Link>
        )}
      </div>
      <UserMenu
        disabled={disabled}
        firstName={firstName}
        lastName={lastName}
        googleAvatarUrl={googleAvatarUrl}
        handleOnLogoutClick={handleOnLogoutClick}
      />
    </div>
  );
};
